import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styledComponents from "styled-components";

import {
  Box,
  Divider,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
  TextField,
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  Modal,
  InputLabel,
  IconButton,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Select,
  Stack,
  Paper,
  Pagination
} from "@mui/material";

import axios from  "axios";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '80%', md: 400 },
    maxHeight: '66vh',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    overflow: 'scroll'
  };
  
  const Container = styledComponents.div`
      padding: 20px;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
  `;

const Pesan = ({ pesanData, updatedData, page, updatedPage, pageInfo, updatedPageInfo, pageSize, updatedPageSize }) => {
    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const [view, setView] = useState(null);

    const handlePage = (event, value) => {
        updatedPage({ value });
        const serviceToken = window.localStorage.getItem('serviceToken');
        const getData = async () => {
            try {
                const getPesanData = await axios.get(`${process.env.REACT_APP_API_URL}/api/dashboard/pesan`, {
                    headers: {
                        Authorization: `Bearer ${JSON.parse(localStorage.getItem('token')).token}`
                    },
                    params: {
                        page: value,
                        perPage: pageSize.value
                    }
                });
                let number = (value - 1) * (pageSize.value);
                updatedData(getPesanData.data.result.data.map((v) => {
                    number+=1;
                    return { ...v, no: number };
                }));
                const pageInfoRes = Object.keys(getPesanData.data.result)
                    .filter((key) => {
                        if (key !== 'data') return true;
                        return false;
                    })
                    .reduce((cur, key) => Object.assign(cur, { [key]: getPesanData.data.result[key] }), {});
                updatedPageInfo(pageInfoRes);
            } catch (err) {
                console.error(err);
            }
        };
        getData();
    };

    return (
        <Container>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle}>
                    <Typography variant="body2">
                        {view}
                    </Typography>
                </Box>
            </Modal>
            <Grid item xs={12} sx={{ margin: '10px 14px'}}>
                <Typography variant="h5" fontWeight="700">Inbox</Typography>
            </Grid>
            <TableContainer component={Paper} sx={{ maxHeight: {xs: '70vh', sm: 740, md: 800} }}>
                <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                        <TableRow>
                            <TableCell>No</TableCell>
                            <TableCell align="left">Judul</TableCell>
                            <TableCell align="left"></TableCell>
                        </TableRow>
                        </TableHead>
                    <TableBody>
                        {pesanData.map((item) => (
                            <TableRow
                                key={item.idnbox}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell>{item.no}</TableCell>
                                <TableCell>{item.judul}</TableCell>
                                <TableCell>
                                    <IconButton
                                        onClick={() => {
                                            handleOpen();
                                            setView(item.judul);
                                        }}>
                                        <RemoveRedEyeIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Grid item xs={12} my={1}>
                <Stack spacing={0}>
                    <Pagination
                        count={pageInfo ? pageInfo.last_page : 10}
                        color="primary"
                        page={page.value}
                        onChange={handlePage}
                        variant="outlined"
                        shape="rounded"
                    />
                </Stack>
            </Grid>
        </Container>
    )
}

export default Pesan
